export default "__VITE_ASSET__CwhUJ_TI__"